module.exports = __webpack_public_path__ + "img/content_right2.854280ca.png";